module.exports = __webpack_public_path__ + "img/q31-1.9a92f14b.jpg";